<template>
  <div style="min-width: 1350px">
    <SubNav
      :title="title"
      :description="description"
      :link="{
        text: 'Warning; this is a mass deletion page, thread with care',
        href: '#',
        class: 'text-danger',
      }"
    >
      <div class="d-flex px-3">
        <div v-for="param in Object.keys(filterParams)" :key="param">
          <dropCard
            :name="cap(param)"
            :placeholder="`Select ${cap(param)}`"
            :label="cap(param)"
            :list="filterLists[param]"
            :values.sync="filterParams[param]"
            multiple
            :default-selected="-1"
            :error="dashboardError[param]"
            :columns="{ lg: 12 }"
            :on-close="filterData"
            classes="pb-3"
          >
            <template #suffix>
              <strong class="text-primary underline d-inline-block pt-2"
                >Select {{ cap(param) }}</strong
              >
            </template>
          </dropCard>
        </div>
      </div>
    </SubNav>
    <div class="container-fluid pb-1">
      <div class="px-4 pt-4">
        <el-alert v-if="dashboardError.data" type="error" class="mb-2">
          <h6>Some data items could not be loaded. Kindly refresh page</h6>
        </el-alert>
        <h5 class="p-2">
          Total data length: {{ filteredData.length }} <small>(Showing: {{ items.length }})</small>
        </h5>
      </div>
      <div class="mb-sm-4 mx-3 my-4 row">
        <div class="col-lg-12">
          <div
            v-loading="loadingList"
            class="border ps-2"
            style="border-width: 4px; border-radius: 5px"
          >
            <TableComponent
              :loading="loadingList"
              :sort-by="sortBy"
              :sort-desc="sortDesc"
              :fields="fields"
              :data="items"
              :paginate="true"
              @selected="handleSelection"
            />
          </div>
          <div class="pt-3 d-flex">
            <download-excel :fetch="getDownload" class="btn btn-primary mr-3" disabled
              >Download xls</download-excel
            >
            <el-popconfirm
              confirm-button-type="danger"
              icon-color="red"
              title="Are you sure to delete data points?"
              @confirm="deleteDataPoints"
            >
              <button
                slot="reference"
                :class="[
                  'btn btn-action',
                  !selectedData.length ? 'disabled btn-dark' : 'btn-danger',
                ]"
                :style="{
                  pointerEvents: selectedData.length ? 'all' : 'none',
                  opacity: selectedData.length ? 1 : 0.3,
                }"
              >
                Delete Data Points
                <!-- <b-icon icon="trash" aria-hidden="true"></b-icon> -->
              </button>
            </el-popconfirm>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import downloadExcel from "vue-json-excel";
import { mapActions } from "vuex";

import TableComponent from "../../../components/Table.vue";
// import AppLink from "../../components/layout/components/Sidebar/Link.vue";
import SubNav from "../../../components/SubNav.vue";
import dropCard from "../../../components/dropCard.vue";
import dataMixin from "../../../mixins/dashboard-data";

export default {
  name: "DataPointsList",
  components: {
    TableComponent,
    // AppLink,
    SubNav,
    dropCard,
    downloadExcel,
  },
  mixins: [dataMixin],
  data() {
    return {
      sortBy: "updated",
      sortDesc: true,
      loadingList: false,
      selectedData: [],
      filterParams: {
        indicators: [],
        datasources: [],
        locations: [],
        valueTypes: [],
        years: [],
      },
      preTypesData: [],
      preYearsData: [],
      filteredData: [],
      items: [],
    };
  },
  computed: {
    indicatorMap() {
      const obj = {};
      for (const ind of this.indicators) {
        obj[ind.id] = ind;
      }
      return obj;
    },
    datasourceMap() {
      const obj = {};
      for (const dat of this.datasources) {
        obj[dat.id] = dat;
      }
      return obj;
    },
    locationMap() {
      const obj = {};
      for (const loc of this.locations) {
        obj[loc.id] = loc;
      }
      return obj;
    },
    valueTypeMap() {
      const obj = {};
      for (const val of this.valueTypes) {
        obj[val.id] = val;
      }
      return obj;
    },
    fields() {
      const fields = [
        "indicator",
        "datasource",
        "location",
        "valueType",
        "period",
        "value",
        "created",
        "updated",
      ];
      return [
        ...fields.map((field) => ({ key: field, label: this.cap(field), sortable: true })),
        { key: "action-buttons", label: "", sortable: false },
      ];
    },
    valueTypeList() {
      if (!this.preTypesData.length) return this.finalValueTypeList;
      const list = this.preTypesData.map((data) => data.value_type);
      return this.finalValueTypeList.filter((vt) => list.some((id) => id == vt.id));
    },
    finalYearList() {
      if (!this.preYearsData.length) {
        const years = [];
        for (let year = new Date().getFullYear(); year >= 1950; year--) {
          years.push({ id: year.toString(), name: year.toString() });
        }
        return years;
      }
      const years = this.preYearsData
        .map((data) => data.period.slice(-4))
        .filter((pd) => Number(pd))
        .sort((a, b) => b - a);
      return [...new Set(years)].map((yr) => ({ id: yr, name: yr }));
    },
    filterLists() {
      return {
        indicators: this.finalIndicatorList,
        datasources: this.finalDatasourceList,
        locations: this.finalLocationList,
        valueTypes: this.valueTypeList,
        years: this.finalYearList,
      };
    },
    title() {
      return "Data Points Management";
    },
    description() {
      return "Select at least one parameter to view data points. Select Multiple parameters to specify on a data points.";
    },
  },
  async created() {
    if (!this.indicators.length || this.dashboardError.indicators) this.loadIndicators();
    if (!this.datasources.length || this.dashboardError.datasources) this.loadDatasources();
    if (!this.valueTypes.length || this.dashboardError.valueTypes) this.loadValueTypes();
    if (!this.locations.length || this.dashboardError.locations) this.loadLocations();
  },
  methods: {
    ...mapActions("activity", ["logActivity"]),
    /**
     *
     */
    handleSelection(items) {
      // console.log(items);
      this.selectedData = items;
    },
    cap(text) {
      return text[0].toUpperCase() + text.slice(1);
    },
    getPreTypesData() {
      const list = Object.values(this.data).sort(
        (a, b) => new Date(b.updated_at) - new Date(a.updated_at)
      );
      if (
        ![
          ...this.filterParams.indicators,
          ...this.filterParams.datasources,
          ...this.filterParams.locations,
        ].length
      )
        return [];
      return list
        .filter(
          (d) =>
            !this.filterParams.indicators.length ||
            this.filterParams.indicators.includes(d.indicator)
        )
        .filter(
          (d) =>
            !this.filterParams.datasources.length ||
            this.filterParams.datasources.includes(d.datasource)
        )
        .filter(
          (d) =>
            !this.filterParams.locations.length || this.filterParams.locations.includes(d.location)
        );
    },
    getPreYearsData() {
      const preYears = this.preTypesData.filter(
        (d) =>
          !this.filterParams.valueTypes.length ||
          this.filterParams.valueTypes.includes(d.value_type)
      );
      return preYears.length ? preYears : this.preTypesData;
    },
    getFilteredData() {
      const filtered = this.preYearsData.filter(
        (d) =>
          !this.filterParams.years.length || this.filterParams.years.includes(d.period.slice(-4))
      );
      return filtered.length ? filtered : this.preYearsData;
    },
    getItems() {
      return this.filteredData.slice(0, 100).map((data) => ({
        id: data.id,
        ...this.populateMeta(data),
        "action-buttons": [
          {
            text: "Edit",
            icon: "edit",
            index: data.id,
            func: () => {
              this.$router.push({ path: "edit", query: data });
            },
          },
        ],
      }));
    },
    async filterData() {
      this.loadingList = true;
      const { indicators, datasources, locations } = this.filterParams;
      if (indicators.length) {
        const toLoad = indicators.filter((ind) => {
          const unloaded = this.indicatorMap[ind] && !this.indicatorMap[ind].loaded;
          if (unloaded) this.setDataLoaded({ indicator: ind });
          return unloaded;
        });
        await Promise.all(toLoad.map((indicator) => this.loadData({ indicator })));
      } else if (datasources.length) {
        const toLoad = datasources.filter((dat) => {
          const unloaded = this.datasourceMap[dat] && !this.datasourceMap[dat].loaded;
          if (unloaded) this.setDataLoaded({ datasource: dat });
          return unloaded;
        });
        await Promise.all(toLoad.map((datasource) => this.loadData({ datasource })));
      } else if (locations.length) {
        const toLoad = locations.filter((loc) => {
          const unloaded = this.locationMap[loc] && !this.locationMap[loc].loaded;
          if (unloaded) this.setDataLoaded({ location: loc });
          return unloaded;
        });
        await Promise.all(toLoad.map((location) => this.loadData({ location })));
      }
      setTimeout(() => {
        this.preTypesData = this.getPreTypesData();
        this.preYearsData = this.getPreYearsData();
        this.filteredData = this.getFilteredData();
        this.items = this.getItems();
        this.loadingList = false;
      }, 0);
    },
    populateMeta(data) {
      return {
        indicator: this.indicatorMap[data.indicator].full_name, // this.indicators.find((ind) => ind.id == data.indicator)?.full_name,
        datasource: this.datasourceMap[data.datasource].datasource, // this.datasources.find((dat) => dat.id == data.datasource)?.datasource,
        location: this.locationMap[data.location].name, // this.locations.find((loc) => loc.id == data.location)?.name,
        period: data.period,
        value: data.value,
        valueType: this.valueTypeMap[data.value_type].value_type, // this.valueTypes.find((vt) => vt.id == data.value_type).value_type,
        created: this.$moment(data.created_at).format("YYYY/MM/DD"),
        updated: this.$moment(data.updated_at).format("YYYY/MM/DD"),
      };
    },
    getDownload() {
      if (this.filteredData.length) {
        this.$notify.success({
          title: "Download",
          message: "in progress",
          duration: 5000,
        });
        return this.filteredData.map((data) => this.populateMeta(data));
      } else {
        this.$notify.error("No data selected!");
      }
    },
    async deleteDataPoints() {
      this.loadingList = true;
      const res = await Promise.all(this.selectedData.map(({ id }) => this.deleteDataPoint(id)));
      if (res.every((r) => r == false)) {
        this.$notify.error({
          title: "An Error Occurred",
          message: "Unable to delete data points!",
          duration: 10000,
        });
      } else if (res.some((r) => r == false)) {
        this.$notify.error({
          title: "An Error Occurred",
          message: "Unable to delete all selected data points!",
          duration: 10000,
        });
      } else {
        this.$notify.success({
          title: "Done",
          message: "Deleted Successfully!",
          duration: 10000,
        });
      }
      await this.filterData();
    },
  },
};
</script>

<style lang="scss" scoped>
.underline {
  text-decoration: underline;
  cursor: pointer;
}
</style>
